<kendo-dialog title="Unassign Restaurant" (close)="onCancel()">
  <kendo-label
    >Are you sure you want to move restaurant
    <strong>{{ restaurant.name }}</strong> back to unassigned?</kendo-label
  >

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">Cancel</button>
    <button kendoButton themeColor="primary" (click)="onAccept()">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
